import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class SponsorQueryFilter extends QueryFilter{
    public outingIterationId: string;
}